import script from "./ChartsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartsSection.vue?vue&type=script&setup=true&lang=js"

import "./ChartsSection.vue?vue&type=style&index=0&id=1948ba10&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1948ba10"]])

export default __exports__